import { render, staticRenderFns } from "./pText.vue?vue&type=template&id=0ec3e416&"
import script from "./pText.vue?vue&type=script&lang=js&"
export * from "./pText.vue?vue&type=script&lang=js&"
import style0 from "./pText.vue?vue&type=style&index=0&id=0ec3e416&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports